
/**
 * Utility functions for image processing
 */

/**
 * Resizes an image if it exceeds the specified dimensions
 */
export const resizeImageIfNeeded = (
  dataUrl: string, 
  maxWidth: number, 
  maxHeight: number,
  callback: (resizedDataUrl: string) => void
) => {
  const img = new Image();
  img.onload = () => {
    // Only resize if the image is larger than max dimensions
    if (img.width > maxWidth || img.height > maxHeight) {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      
      // Calculate new dimensions while maintaining aspect ratio
      let newWidth = img.width;
      let newHeight = img.height;
      
      if (newWidth > maxWidth) {
        newHeight = (maxWidth / newWidth) * newHeight;
        newWidth = maxWidth;
      }
      
      if (newHeight > maxHeight) {
        newWidth = (maxHeight / newHeight) * newWidth;
        newHeight = maxHeight;
      }
      
      canvas.width = newWidth;
      canvas.height = newHeight;
      
      ctx?.drawImage(img, 0, 0, newWidth, newHeight);
      callback(canvas.toDataURL('image/jpeg', 0.8));
    } else {
      // Image is already small enough, return original
      callback(dataUrl);
    }
  };
  img.src = dataUrl;
};
